import { HttpClient } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MobilePhoneNumberService, NationalCodeService } from 'ngx-persian';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';
import { PersianNumberService } from 'ngx-persian';
import { MapService } from 'src/app/services/map.service';
import * as moment from 'moment-jalaali';
import { MatSnackBar } from '@angular/material/snack-bar';
import Swal from 'sweetalert2';
import { GeolocationData, MapBuilderService } from 'src/app/services/map-builder.service';
import { catchError, Observable, of, Subject, switchMap, takeUntil, throwError } from 'rxjs';
declare let $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-new-trip',
  templateUrl: './new-trip.component.html',
  styleUrls: ['./new-trip.component.css'],
})

export class NewTripComponent implements OnInit {
  list_City: any[] = [];
  list_MobileGroup: any[] = [];
  list_Reason: any[] = [];
  list_ReliefType: any[] = [];
  list_MobileType: any[] = [];

  bForAnother: Boolean = false;
  bHasStop: Boolean = false;
  bCargo: Boolean = false;
  bForeigner: Boolean = false;
  bInvoiceRequired: Boolean = false;
  showCustom_Map: boolean = false;
  isInput_Disabled: boolean = false;
  isRequestingLocation: boolean = false;

  iState: number = 1;
  map: any;
  source: any;
  vector: any;
  layers: any = [];
  mapHeader: any;
  mapMode: any;
  vectorLayer: any;
  origin: any;
  destination: any;
  Info: any;
  currentTime: any = moment().format('jYYYY/jMM/jDD');
  currentClock: any;
  prices: any;
  invoice: any;
  atLeastTime: number;
  plateValues: string[] = ['', '', '', ''];

  private destroy$ = new Subject<void>();

  constructor(
    private accountService: AccountService,
    private router: Router,
    private otherService: OtherService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private persianNumber: PersianNumberService,
    private _NationalCode: NationalCodeService,
    private _MapService: MapService,
    private snackBar: MatSnackBar,
    private mapBuilderService: MapBuilderService
  ) { }

  mdl_Map: FormGroup = this.formBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  });

  mdl_TripSAD: FormGroup = this.formBuilder.group({
    iTaxiLon_User: new FormControl(''),
    strSession: new FormControl('-1'),
    tiMobileType: new FormControl('-1', Validators.required), // نوع خودرو 
    tiReason4Request: new FormControl('-1', Validators.required), // علت درخواست 
    tiReliefRequestType: new FormControl('-1', Validators.required), // نوع درخواست امداد 
    strReasonStopping: new FormControl(''), // دلیل توقف   
    tiMobileGroup: new FormControl('', Validators.required), // نوع جرثقیل 
    strSCity: new FormControl('', Validators.required), // شهر مبدا
    strSAddress: new FormControl('', Validators.required), // آدرس مبداء
    fSLat: new FormControl(0, Validators.required), // موقعیت مبدا
    fSLon: new FormControl(0, Validators.required), // موقعیت مبدا
    strDCity: new FormControl(''), // شهر مقصد
    strDAddress: new FormControl(''), // آدرس مقصد
    fDLat: new FormControl(0), // موقعیت مقصد
    fDLon: new FormControl(0), // موقعیت مقصد
    strDate: new FormControl(this.persianNumber.toEnglish(new Date().toLocaleString('fa-ir')), Validators.required), // تاریخ
    strTime: new FormControl('', Validators.required), // ساعت
    bTraffic: new FormControl(false), // چک باکس طرح ترافیک
    bEvenOdd: new FormControl(false), // چک باکس طرح آلودگی 
    bBadWeather: new FormControl(false), // چک باکس شرایط آب وهوایی ویژه 
    bMountainous: new FormControl(false), // چک باکس منطقه کوهستانی 
    strComment: new FormControl(''), // توضیحات
    strVehicleNo: new FormControl(''), // پلاک
    strVehicleNo_1: new FormControl(''),
    strVehicleNo_2: new FormControl(''),
    strVehicleNo_3: new FormControl(''),
    strVehicleNo_4: new FormControl(''),
  });

  mdl_Payment: FormGroup = this.formBuilder.group({
    iTaxiLon_User: this.otherService.getLocalStorage().Id,
    strSession: this.otherService.getLocalStorage().session,
    iTaxiLon_Trip: new FormControl(''),
    strSuccessURL: new FormControl(''),
    tiAppType: new FormControl('2')

  })

  mdl_Voting: FormGroup = this.formBuilder.group({
    iTaxiLon_User: this.otherService.getLocalStorage().Id,
    strSession: this.otherService.getLocalStorage().session,
    iTaxiLon_Trip: new FormControl(''),
    iDriverPoints: new FormControl(''),
    tiDriverPoints: new FormControl(''),
    strPassengerOpinion: new FormControl(''),
    strSCityName: new FormControl(''),
    strDCityName: new FormControl(''),
    strDate: new FormControl(''),
    iEmdadRo: new FormControl(''),
  })

  ngOnInit(): void {
    this.Info = this.otherService.getLocalStorage();
    if (this.Info?.strVehicleNo) {
      const [first, second, third, pipe, fourth] = this.Info?.strVehicleNo.split(' ');
      this.mdl_TripSAD.patchValue({
        strVehicleNo_1: first,
        strVehicleNo_2: second,
        strVehicleNo_3: third,
        strVehicleNo_4: fourth
      })
    }

    this.getAtleastTime();
    this.getListCity();
    this.check_hasVoted();
    this.getMobileGroup()
  }

  ngAfterViewInit() {
    this.mdl_TripSAD.get('strSAddress')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.mdl_TripSAD.patchValue({
        fSLat: '',
        fSLon: ''
      });
    });

    this.mdl_TripSAD.get('strDAddress')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.mdl_TripSAD.patchValue({
        fDLat: '',
        fDLon: ''
      });
    })
  }

  ngOnDestroy() {
    $("#map_Modal").modal("hide");
    this.otherService.setTitle('');

    this.destroy$.next();
    this.destroy$.complete();

  }

  check_hasVoted() {

    var model = {

      iTaxiLon_User: this.Info.Id,

      strSession: this.Info.session

    }

    this.accountService.taxiLon_CheckPoints(model).subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      if (res.length && res[0].strDate) {

        this.mdl_Voting.patchValue({
          iTaxiLon_Trip: res[0].iTaxiLon_Trip,
          strDate: res[0].strDate,
          strSCityName: res[0].strSCityName,
          strDCityName: res[0].strDCityName,
          iEmdadRo: res[0].iEmdadRo,
        })

        var myModal = new bootstrap.Modal(document.getElementById('Voting_Modal'), {});
        myModal.show();

      }

    });

  }

  submitRequest() {
    let model = this.mdl_TripSAD.value;

    model.iTaxiLon_User = this.Info.Id;
    model.strSession = this.Info.session;

    if (this.mdl_TripSAD.invalid) {
      return this.accountService.toastSwal('error', '!لطفا موارد ستاره دار را وارد کنید');
    }

    if (model.strTime.trim() == '') {
      return this.accountService.toastSwal('error', 'ساعت را وارد کنید');
    }

    if (model.strVehicleNo_1.trim() == '' || model.strVehicleNo_2.trim() == '' || model.strVehicleNo_3.trim() == '' || model.strVehicleNo_4.trim() == '') {
      return this.accountService.toastSwal('error', 'پلاک خودرو را وارد کنید');
    }

    if (model.strDate < this.currentTime) {
      return this.accountService.toastSwal('error', 'تاریخ قبل از امروز را نمی توانید انتخاب کنید');
    }

    if (model.strSCity == '') {
      return this.accountService.toastSwal('error', 'شهر مبدا را وارد کنید');
    }

    if (model.strSAddress == '') {
      return this.accountService.toastSwal('error', 'آدرس مبدا را وارد کنید');
    }

    if (model.fSLon == '') {
      return this.accountService.toastSwal('error', 'موقعیت مبدا را وارد کنید');
    }

    if (model.tiMobileType == '-1') {
      return this.accountService.toastSwal('error', 'نوع خودرو را مشخص کنید');
    }

    if (model.tiReliefRequestType == '-1') {
      return this.accountService.toastSwal('error', 'نوع درخواست را مشخص کنید');
    }

    if (model.tiReason4Request == '-1' && !this.isInput_Disabled) {
      return this.accountService.toastSwal('error', 'علت درخواست را مشخص کنید');
    }

    if (model.tiMobileGroup == '-1' && !this.isInput_Disabled) {
      return this.accountService.toastSwal('error', 'نوع امدادگر را مشخص کنید');
    }

    if (model.strVehicleNo_1) {

      model.strVehicleNo = model.strVehicleNo_1 + ' ' + model.strVehicleNo_2 + ' ' + model.strVehicleNo_3 + ' | ' + model.strVehicleNo_4;

    }

    let showConfirmationDialog = (message: string, model: any) => {

      Swal.fire({

        title: "آیا از ثبت درخواست حمل اطمینان دارید ؟",

        icon: 'warning',

        iconHtml: '?',

        html: message,

        showCancelButton: true,

        reverseButtons: true,

        confirmButtonColor: '#10b981',

        cancelButtonColor: '#EF4444',

        confirmButtonText: 'تایید',

        cancelButtonText: 'لغو',

      }).then((result) => {
        if (result.isConfirmed) {
          this.accountService.EmdadRo_User_Save(this.otherService.stringNumberToNumber(model)).subscribe((data: any) => {
            let res = JSON.parse(data.toString());
            if (res.iResult === 0) {
              return this.accountService.toastSwal('error', res.strError);
            }
            const code = res[0]?.iEmdadRo ? `با کد : ${res[0].iEmdadRo}` : '';
            this.accountService.toastSwal('success', `درخواست شما ${code} ثبت گردید و بزودی به آن رسیدگی بعمل می آید`, 6000);
            this.router.navigateByUrl('/all-request');
          });
        }
      });
    }

    if (model.fSLon && model.fSLat && this.isUser_OpenedMap()) {

      this.accountService.TaxiLon_User_TravelCostEstimate(this.otherService.stringNumberToNumber(model)).subscribe((data: any) => {

        let res = JSON.parse(data.toString());

        if (res.iResult === 0) return this.accountService.toastSwal('error', res.strError);

        let message = res.iRent ? `

              <p class="fs-6"> مسافت : <strong> ${res.fKm} کیلومتر  </strong> </p>

              <p class="fs-6"> هزینه حمل(ریال) : <strong> ${res.iRent.toLocaleString()} </strong> </p>

              <p class="fs-6"> مبلغ پیش پرداخت (ریال) : <strong> ${res.iAdvancePayment.toLocaleString()} </strong> </p> ` : '';

        showConfirmationDialog(message, model);

      });

    }

    else {

      showConfirmationDialog('', model);

    }

  }

  isUser_OpenedMap(): boolean {

    let model = this.mdl_TripSAD.value;

    if (!model.fDLon || !model.fDLat) {

      return false;

    }

    else if (model.fDLon && model.fDLat) {

      return !Boolean(this.list_City.find((el) => (el.fLat == model.fDLat && el.fLon && model.fDLon)))

    }

  }

  getListCity = async () => {
    this.accountService.TaxiLon_City_List().subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      this.list_City = res;
      this.mdl_TripSAD.patchValue({
        strSCity: this.Info.strCity,
        strSAddress: this.Info.strAddress,
        fSLat: this.Info.fLat,
        fSLon: this.Info.fLon
      }, { emitEvent: false });
    });
  }

  getAtleastTime() {

    this.accountService.TaxiLon_AtLeastTime().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.atLeastTime = res;

      this.mdl_TripSAD.patchValue({

        strTime: moment().format("HH:mm")

      })

    });

  }

  tripSubmit() {
    let model = this.mdl_TripSAD.value;

    model.iTaxiLon_User = this.Info.Id;

    model.strSession = this.Info.session;

    model.iAdvancePayment = this.invoice.iAdvancePayment;

    model.iEstimateRent = this.invoice.iPrice;

    this.accountService.TaxiLon_Trip_Passenger_Save(model).subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      if (res[0].iTaxiLon_Trip) {

        if (res[0].tiTripStatus == 0) {

          this.mdl_Payment.patchValue({

            iTaxiLon_Trip: res[0].iTaxiLon_Trip,

            strSuccessURL: `${window.location.origin}/payment/callback/prepayment`

          })

          return this.payInvoice();

        }

        else {

          this.accountService.toastSwal('success', ` سفر شما با کد رهگیری ${res[0].iTaxiLon_Trip} ثبت شد`);

          this.router.navigate(['/all-request']);

        }

      }

      else {
        // this.accountService.toastSwal('error', `خطایی در ثبت سفر رخ داد`)
        return this.accountService.toastSwal('error', 'خطا');
      }

    });
  }

  payInvoice() {
    this.accountService.taxiLon_PayInvoice(this.mdl_Payment.value).subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      if (res.iResult == 0) {
        return this.accountService.toastSwal('error', res.strError);
      }

      window.open(res.strURL, '_self')

    });

  }

  setValue_Filter(event: any, strKey: string) {
    if (event?.strCityName) {
      if (strKey == 'strSCity') {
        this.mdl_TripSAD.patchValue({
          strSCity: event.strCity,
          fSLon: event.fLon,
          fSLat: event.fLat,
          strSAddress: ''
        }, { emitEvent: false });
      }

      else {
        this.mdl_TripSAD.patchValue({
          strDCity: event.strCity,
          fDLon: event.fLon,
          fDLat: event.fLat,
          strDAddress: ''
        }, { emitEvent: false });
      }

    }

    else {

      if (strKey == 'strSCity') {
        this.mdl_TripSAD.patchValue({
          strSCity: '',
          fSLon: '',
          fSLat: '',
          strSAddress: ''
        }, { emitEvent: false });
      }

      else {
        this.mdl_TripSAD.patchValue({
          strDCity: '',
          fDLon: '',
          fDLat: '',
          strDAddress: ''
        }, { emitEvent: false });
      }
    }
  }

  submitMap(event: any) {
    this.showCustom_Map = false;

    if (this.mdl_Map.get('strSource')?.value == 'strSAddress') {
      if (event.strText != '') {
        this.mdl_TripSAD.patchValue({
          strSAddress: event.strText,
          fSLon: event.longitude,
          fSLat: event.latitude,
        }, { emitEvent: false });
      }

      else {
        this.mdl_TripSAD.patchValue({
          strSAddress: '',
          fSLon: '',
          fSLat: '',
        }, { emitEvent: false });
      }
    }

    else {
      if (event.strText != '') {
        this.mdl_TripSAD.patchValue({
          strDAddress: event.strText,

          fDLon: event.longitude,

          fDLat: event.latitude,
        }, { emitEvent: false });
      } else {
        this.mdl_TripSAD.patchValue({
          strDAddress: '',

          fDLon: '',

          fDLat: '',
        }, { emitEvent: false });
      }
    }
  }

  returnStrValue(
    strKey: string,
    strKeyValue: number | string,
    lst_: [] | any,
    strComment: string
  ): string {
    return this.otherService.initialFilterValue(
      strKey,
      strKeyValue,
      lst_,
      strComment
    );
  }

  visiblityForAnother() {
    if (this.mdl_TripSAD.value.bForAnother == false) {
      this.bForAnother = false;
    } else {
      this.bForAnother = true;
    }
  }

  visiblityHasStop() {
    if (this.mdl_TripSAD.value.bHasStop == false) {
      this.bHasStop = false;
    } else {
      this.bHasStop = true;
    }
  }

  visiblityCargo() {
    if (this.mdl_TripSAD.value.bCargo == false) {
      this.bCargo = false;
    } else {
      this.bCargo = true;
    }
  }

  visiblityInvoiceRequired() {
    if (this.mdl_TripSAD.value.bInvoiceRequired == false) {
      this.bInvoiceRequired = false;
    } else {
      this.bInvoiceRequired = true;
    }
  }

  visiblityForeigner() {
    if (this.mdl_TripSAD.value.bForeigner == false) {
      this.bForeigner = false;
    } else {
      this.bForeigner = true;
    }
  }

  showAgree() {
    if (this.mdl_TripSAD.value.bAgreement == true) {
      this.bForAnother = false;
    } else {
      this.bForAnother = true;
    }
  }

  submitVote() {

    if (!this.mdl_Voting.get('iDriverPoints')?.value.rating || this.mdl_Voting.get('iDriverPoints')?.value.rating == '') {

      return this.accountService.toastSwal('error', 'میزان رضایت خود را مشخص کنید');

    }

    else {

      this.mdl_Voting.get('tiDriverPoints').setValue(this.mdl_Voting.get('iDriverPoints')?.value.rating);

      this.accountService.taxiLon_SetPoints(this.otherService.stringNumberToNumber(this.mdl_Voting.value)).subscribe((data: any) => {

        let res = JSON.parse(data.toString());

        if ([-1, 0].includes(res.iResult)) {
          return this.accountService.toastSwal('error', res.strError);
        }

        bootstrap.Modal.getInstance(document.getElementById('Voting_Modal')).hide();
        this.accountService.toastSwal('success', 'نظر شما با موفقیت ثبت شد');

      });

    }

  }

  getMobileGroup = async () => {

    this.accountService.getMobileType().subscribe((data: any) => {

      this.list_MobileType = data;

    });

    this.accountService.getMobileGroup().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.list_MobileGroup = res;

    });

    this.accountService.getReason4Request().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.list_Reason = res;


    });

    this.accountService.getReliefType().subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.list_ReliefType = res;

    });


  }

  updateValue(value) {

    this.mdl_TripSAD.get('tiReliefRequestType')?.setValue(value);

    if (value >= 2) {

      this.clearField({

        tiReason4Request: 0,

        tiMobileGroup: 0,

        strDCity: '',

        strDAddress: '',

        fDLat: 0,

        fDLon: 0

      });

      this.updateValidity({

        strComment: '',


      })

      this.isInput_Disabled = true;


    }

    else {

      this.isInput_Disabled = false;

      this.updateValidity({

        tiReason4Request: -1,

        tiMobileGroup: -1

      })

      this.clearField({

        strComment: '',

        strDCity: '',

        strDAddress: '',

        fDLat: 0,

        fDLon: 0,

      });

    }

  }

  private updateValidity(fields: { [key: string]: any }) {

    Object.entries(fields).forEach(([key, value]) => {
      const control = this.mdl_TripSAD.get(key);
      control.setValidators(Validators.required);
      control.setValue(value);
      control.updateValueAndValidity();
    })

  }

  private clearField(fields: { [key: string]: any }) {

    Object.entries(fields).forEach(([key, value]) => {
      const control = this.mdl_TripSAD.get(key);
      if (control) {
        control.setValue(value);
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });

  }

  // handle map and address

  public openMap(type: 'strSAddress' | 'strDAddress'): void {
    const model = this.mdl_TripSAD.value;

    if (type == 'strSAddress') {
      const cityId = model.strSCity;
      const address = model.strSAddress;
      const cityName = this.getCityNameById(cityId, this.list_City);

      if (cityId.trim() === '') {
        this.accountService.toastSwal('error', 'شهر مبداء را انتخاب کنید');
        return;
      }

      if (address.trim() === '') {
        this.requestAndSetCurrentLocation(type).subscribe({
          error: (err) => {
            const defaultCoords = { lat: model.fSLat, lon: model.fSLon };
            if (defaultCoords.lat && defaultCoords.lon) {
              this.setMapWithFixedLocation('', defaultCoords.lon, defaultCoords.lat, type);
            }
          }
        })
      }

      else {
        const finalAddress = this.buildFullAddress(cityName, address);
        this.setMapWithFixedLocation(finalAddress, model.fSLon, model.fSLat, type);
      }

    }

    else {
      const cityId = model.strDCity;
      const address = model.strDAddress;
      const cityName = this.getCityNameById(cityId, this.list_City);

      if (cityId.trim() === '') {
        this.accountService.toastSwal('error', 'شهر مقصد را انتخاب کنید');
        return;
      }

      if (address.trim() === '' && model.fDLon === 0) {
        this.requestAndSetCurrentLocation(type).subscribe({
          error: (err) => {
            const defaultCoords = { lat: model.fDLat, lon: model.fDLon };
            if (defaultCoords.lat && defaultCoords.lon) {
              this.setMapWithFixedLocation('', defaultCoords.lon, defaultCoords.lat, type);
            }
          }
        });
      }

      else {
        const finalAddress = this.buildFullAddress(cityName, address);
        this.setMapWithFixedLocation(finalAddress, model.fDLon, model.fDLat, type);
      }

    }

  }

  private getCityNameById(cityId: string, cityList: any[], cityNameKey: string = 'strCityName'): string {
    if (!cityId || !cityList) {
      return '';
    }

    const city = cityList.find(c => c.strCity === cityId);
    return city ? city[cityNameKey] : '';
  }

  private buildFullAddress(cityName: string, address: string): string {
    if (!address) {
      return '';
    }

    return !address.startsWith(cityName) ? `${cityName}، ${address}` : address;
  }

  private requestAndSetCurrentLocation(source: 'strSAddress' | 'strDAddress'): Observable<GeolocationData> {
    this.isRequestingLocation = true;
    return this.mapBuilderService.requestCurrentLocation$().pipe(
      switchMap((location: GeolocationData) => {
        const coordinates: [number, number][] = [[location.longitude, location.latitude]];
        this.mapBuilderService.fitMapToCoordinates(coordinates);
        this.mdl_Map.patchValue({
          strAddress: '',
          fLon: location.longitude,
          fLat: location.latitude,
          strSource: source,
        });
        this.showCustom_Map = true;
        this.isRequestingLocation = false;
        return of(location);
      }),
      catchError((err) => {
        this.toastr.error('', err);
        this.isRequestingLocation = false;
        this.showCustom_Map = true;
        return throwError(() => new Error(err));
      })
    );
  }

  private setMapWithFixedLocation(address: string, longitude: number, latitude: number, source: 'strSAddress' | 'strDAddress'): void {
    this.mdl_Map.patchValue({
      strAddress: address,
      fLon: longitude,
      fLat: latitude,
      strSource: source,
    });

    this.showCustom_Map = true;
  }

  filterNumericInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9۰-۹]/g, '')
  }


}
